import {
  blue,
  green,
  red,
  yellow,
  orange,
  purple,
  grey,
} from "@mui/material/colors";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import * as DefaultRoutes from "@Routes/DefaultRoutes";
import GenericHomePage from "@Pages/GenericHomePage/GenericHomePage";
import EditCalendarRoundedIcon from "@mui/icons-material/EditCalendarRounded";
import MarkEmailUnreadRoundedIcon from "@mui/icons-material/MarkEmailUnreadRounded";
import FactCheckRoundedIcon from "@mui/icons-material/FactCheckRounded";
import FolderCopyRoundedIcon from "@mui/icons-material/FolderCopyRounded";
import DriveFileMoveRoundedIcon from "@mui/icons-material/DriveFileMoveRounded";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

const RDManagerHome = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  let sectionsBox = [
    {
      textBeside: "Incoming Exit Requests",
      icon: MarkEmailUnreadRoundedIcon,
      iconColor: blue[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: blue[100],
      onClick: () => navigate(DefaultRoutes.rdManagerIncomingRequests),
    },
    {
      textBeside: "My Impact Assessments",
      icon: FactCheckRoundedIcon,
      iconColor: grey[600],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: grey[200],
      onClick: () => navigate(DefaultRoutes.rdManagerResponses),
    },
    {
      textBeside: "Exit Plans",
      icon: EditCalendarRoundedIcon,
      iconColor: purple[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: purple[100],
      onClick: () => navigate(DefaultRoutes.rdManagerExitPlans),
    },
    {
      textBeside: "My Regulatory Exemptions",
      icon: ReceiptLongIcon,
      iconColor: orange[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: orange[100],
      onClick: () => navigate(DefaultRoutes.rdManagerExemptions),
    },
    {
      textBeside: "Regulatory Ingredients Hub",
      icon: FolderCopyRoundedIcon,
      iconColor: green[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: green[100],
      onClick: () => navigate(DefaultRoutes.activeReqs),
    },
    {
      textBeside: "Delegation Requests",
      icon: DriveFileMoveRoundedIcon,
      iconColor: grey[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: grey[100],
      onClick: () => navigate(DefaultRoutes.rdManagerDelegationRequests),
    },
  ];

  return <GenericHomePage sectionsBox={sectionsBox} />;
};

export default RDManagerHome;
